import type { FC } from 'react'
import { Autocomplete, TextField, Checkbox as MuiCheckbox } from '@mui/material'
import MuiIconCheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import MuiIconCheckBox from '@mui/icons-material/CheckBox'
import { Service } from '~/entities/steerage'

const checkboxIcon = <MuiIconCheckBoxOutlineBlank fontSize="small" />
const checkedCheckboxIcon = <MuiIconCheckBox fontSize="small" />

interface ServiceValueType {
  id: number
  service: string
  category: string
}

interface ServiceAutocompleteProps {
  onChangeService: (value: ServiceValueType[]) => void
  services: Service[]
  selectedServices: Service[]
  disabled?: boolean
}

const ServiceAutocomplete: FC<ServiceAutocompleteProps> = props => {
  const selectedService = props?.selectedServices.map(option => {
    return {
      category: option?.category?.description,
      id: option.id,
      service: option.description == 'z Other' ? 'Other' : option.description,
    } as ServiceValueType
  })
  return (
    <Autocomplete
      disabled={props?.disabled}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      multiple
      disableCloseOnSelect
      filterSelectedOptions
      size="small"
      options={props?.services?.map(
        option =>
          ({
            key: option.id,
            category: option?.category?.description,
            id: option.id,
            // We have added service as "z Other" instead of "Other" because we needed to
            // sort the "Other" at the last position in the service list for the category
            service: option.description == 'z Other' ? 'Other' : option.description,
          }) as ServiceValueType,
      )}
      groupBy={option => option.category}
      getOptionLabel={option => option.service}
      isOptionEqualToValue={(option, value) =>
        option.category == value.category && option.id == value.id
      }
      renderInput={params => <TextField variant="standard" {...params} label={'Services'} />}
      renderOption={({ key, ...props }, option, { selected }) => (
        <li key={key} {...props}>
          <MuiCheckbox
            icon={checkboxIcon}
            checkedIcon={checkedCheckboxIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.service}
        </li>
      )}
      value={selectedService}
      onChange={(event, value) => {
        props?.onChangeService(value)
      }}
    />
  )
}

export default ServiceAutocomplete
